import React, { FC } from 'react';
import ProfileLoginComponent from './ProfileLoginComponent';
import ProfileAvatarComponent from './ProfileAvatarComponent';

const UtilityComponent: FC = () => (
  <ProfileLoginComponent>
    <ProfileAvatarComponent />
  </ProfileLoginComponent>
);

UtilityComponent.displayName = 'UtilityComponent';
export default UtilityComponent;
